import React from "react";
import { RiderShell } from "@/components/Shells";
import AccountView from "@/components/AccountView";

export default function RiderAccount() {
  return (
    <RiderShell>
      <AccountView />
    </RiderShell>
  );
}
